import React, { useEffect, useState, useRef, useCallback } from "react";
import {
    Button,
    Form,
    Table,
    Spinner,
    Modal,
    Container,
    Row,
    Col,
    InputGroup,
    ListGroup,
} from "react-bootstrap";
import { motion } from "framer-motion";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import { Helmet } from 'react-helmet';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import Titulo from '../elements/Titulo';




const fetchProductosAPI = async (page, limit, query) => {
    // Simulación de API paginada con filtro
    return new Promise((resolve) => {
        setTimeout(() => {
            const total = 100;
            const start = page * limit;
            const data = Array.from({ length: limit }, (_, i) => {
                const id = start + i + 1;
                return {
                    id,
                    name: `Producto ${id}${query ? ` - ${query}` : ""}`,
                };
            });
            resolve(data);
        }, 1000);
    });
};

const LoadingOverlay = ({ show }) => (
    show && (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
            }}
        >
            <Spinner animation="border" variant="light" />
        </div>
    )
);

const PurchaseOrders = () => {
     const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [query, setQuery] = useState("");
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [showLoadModal, setShowLoadModal] = useState(false);
    const [savedPedidos, setSavedPedidos] = useState([]);
    const [savedPurchase, setSavedPurchase] = useState([]);
    const [page, setPage] = useState(0);
    const loader = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 60;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const fetchProducts = useCallback(async () => {
        setLoading(true);
        getitems();
        setLoading(false);
    }, [page, query]);

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prev) => prev + 1);
                }
            },
            { threshold: 1 }
        );
        if (loader.current) observer.observe(loader.current);
        return () => loader.current && observer.unobserve(loader.current);
    }, []);

    const filteredItems = items.filter((item) => {
        return (
            item.product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });


    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
    const sortItems = [...currentItems].sort((a, b) => {
        return a.description.localeCompare(b.description);
    });

    const getitems = async () => {
        await dotoniwoofApi.get(`/item.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setItems(responseApi.message);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };
    const addProduct = (product) => {
        console.log(product)
        if (!selected.some((item) => item.id_item === product.id_item)) {
            setSelected([...selected, { ...product, quantity: 1 }]);
        }
    };

    const removeProduct = (id) => {
        setSelected(selected.filter((item) => item.id_item !== id));
    };

    const savePedido = async () => {
        const purchaseName = prompt("Nombre del pedido:");
        if (!purchaseName) return;
      
   
        
        setLoading(true);
        try {
          await dotoniwoofApi.post("/purchaseOrder.php", {
            firebase_UID: user.uid,
            purchase_name: purchaseName,
            json_purchase_detail: JSON.stringify(selected),
          });
          
          alert("Pedido guardado exitosamente.");
        } catch (error) {
          console.error("Error al guardar el pedido:", error);
          alert("Ocurrió un error al guardar el pedido.");
        }
        setLoading(false);
    };

    const loadPedidos = async () => {
           
        setLoading(true);
        await dotoniwoofApi.get(`/purchaseOrder.php`)
        .then(res => {
            let responseApi = res.data;
            if (responseApi.code === 200) {
               setSavedPurchase(responseApi.message);
            }

        })
        .catch(err => {
            console.log(err);
        }).finally(
            () => {
                setLoading(false);
            }
        )
    };

    useEffect(() => {
        if (savedPurchase.length > 0) {
            setSavedPedidos(savedPurchase);
            setShowLoadModal(true);
        }
    }, [savedPurchase]);

    const completarPedido = async () => {
       
        setLoading(true);
   
        const doc = new jsPDF();
        doc.text("Pedido de Productos", 10, 10);
        autoTable(doc,{
            head: [["Nombre", "Cantidad"]],
            body: selected.map((item) => [item.product.name + " " +item.weight.weight_name, item.quantity]),
        });
        doc.save("pedido.pdf");
        setLoading(false);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowEditModal(true);
    };

    const handleUpdate = () => {
        setSelected(
            selected.map((item) =>
                item.id_item === editItem.id_item ? { ...item, quantity: editItem.quantity } : item
            )
        );
        setShowEditModal(false);
    };

    return (
        <>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            <Helmet><title>
                Items
            </title></Helmet>
            <Container>
                <LoadingOverlay show={loading} />

                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                    <Row className="my-3">
                        <Col>
                            <InputGroup>
                                <Form.Control
                                    placeholder="Buscar productos"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Button onClick={loadPedidos} variant="outline-secondary">
                                    Cargar Pedido
                                </Button>
                            </InputGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6} style={{ maxHeight: "60vh", overflowY: "auto" }}>
                            <h4>Productos Disponibles</h4>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortItems.map((item) => (
                                        <tr key={item.id_item}>

                                            <td>{item.product.name} {item.weight.weight_name !== "N/A" && <></>}
                                            {item.weight.weight_name !== "N/A" && item.weight.weight_name} {item.color.color_name !== "N/A" && <></>}
                                                {item.color.color_name !== "N/A" && item.color.color_name} {item.size.size_name !== "N/A" && <></>}
                                                {item.size.size_name !== "N/A" && item.size.size_name}</td>
                                            <td>
                                                <Button size="sm" onClick={() => addProduct(item)}>
                                                    Agregar
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div ref={loader} />
                        </Col>

                        <Col md={6}>
                            <h4>Productos del Pedido</h4>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Cantidad</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selected.map((item) => (
                                        <tr key={item.id_item}>
                                            <td>{item.product.name} {item.weight.weight_name !== "N/A" && <></>}
                                            {item.weight.weight_name !== "N/A" && item.weight.weight_name} {item.color.color_name !== "N/A" && <></>}
                                                {item.color.color_name !== "N/A" && item.color.color_name} {item.size.size_name !== "N/A" && <></>}
                                                {item.size.size_name !== "N/A" && item.size.size_name}</td>
                                            <td>{item.quantity}</td>
                                            <td>
                                                <Button
                                                    size="sm"
                                                    variant="warning"
                                                    onClick={() => handleEdit(item)}
                                                >
                                                    Editar
                                                </Button>{" "}
                                                <Button
                                                    size="sm"
                                                    variant="danger"
                                                    onClick={() => removeProduct(item.id_item)}
                                                >
                                                    Eliminar
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <Button variant="primary" onClick={savePedido} className="me-2">
                                Guardar Pedido
                            </Button>
                            <Button variant="success" onClick={completarPedido}>
                                Completar Pedido
                            </Button>
                        </Col>
                    </Row>
                </motion.div>

                {/* Modal editar */}
                <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Cantidad</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Control
                            type="number"
                            value={editItem?.quantity || 1}
                            onChange={(e) =>
                                setEditItem({ ...editItem, quantity: parseInt(e.target.value) })
                            }
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleUpdate}>Actualizar</Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal cargar pedido */}
                <Modal show={showLoadModal} onHide={() => setShowLoadModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Pedidos Guardados</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ListGroup>
                            {savedPedidos.map((pedido, index) => (
                                <ListGroup.Item
                                    key={index}
                                    action
                                    onClick={() => {
                                        setSelected(JSON.parse(pedido.json_purchase_detail));
                                        setShowLoadModal(false);
                                    }}
                                >
                                    {pedido.purchase_name}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    );
};

export default PurchaseOrders;